<template>
	<div class="leftMenu" :style="[{width: `${ width }px`}]">
		<div class="Menu" v-for="(item,index) of MenuList" :key="index">
			<!-- {{ item.Nodes }} -->
			<!-- 一级菜单 -->
			<div v-if="item.Nodes == null && item.Path != 'button'" @click="MenuDClick(item.NodeID , item.Path)"
				:class=" onchage == item.NodeID ? 'MenuD' : 'MenuDs' ">
				<div class="MenuD-icon">
					<!-- ../../../../../assets/channel/menu/OK1.png -->
					<img src="" alt="">
				</div>
				<div class="MenuDTitle">
					{{ item.NodeName }}
				</div>
				<div :class=" onchage == item.NodeID ? 'MenuDR' : '' ">
				</div>
			</div>
			<!-- 二级菜单 -->
			<div>
				<div class="MenuSBox" v-if="item.Nodes != null">
					<div class="MenuS" @click.prevent="MenuSClickW(index)">
						{{ item.NodeName }}
						<img src="../../../../../assets/channel/menu/menuDown.png" alt=""
							:class="item.Checked ? 'imgMenu' : 'imgsMenu'">
					</div>
					<collapse-transition>
						<div v-if="item.Checked" style="overflow: hidden">
							<div class="DownList" ref="DownList" v-for="(items , indexs) of item.Nodes" :key="indexs">
								<div @click="DownSecondClick(items.NodeID , items.Path )"
									:class=" onchages == items.NodeID ? 'DownDatas' : 'DownData' ">
									<div class="MenuS-icon">
										<img v-if="items.LicenseStatus == 1"
											src="../../../../../assets/channel/menu/OK1.png" alt="">
										<img v-else src="" alt="">
									</div>
									<div class="MenuStitle">
										{{ items.NodeName }}
									</div>
									<div :class=" onchages == items.NodeID ? 'MenuDRScound' : 'MenuDRScounds' ">
									</div>
								</div>
							</div>
						</div>
					</collapse-transition>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import CollapseTransition from '../../../../../common/transition'
	export default {
		components: {
			'collapse-transition': CollapseTransition
		},
		props: {
			MenuList: {
				type: Array
			},
			width: {
				type: Number,
				default: 258
			}
		},
		data() {
			return {
				MenuDR: false, //一级菜单样式
				MenuDRScound: false, //二级菜单列表样式
				colorData: this.color, // 一级选中字体颜色
				backgroundColorDData: this.backgroundColorD, // 一级菜单选中颜色
				colorDataSecond: this.colorDataS, //二级选中字体颜色
				backgroundColorDataSecond: this.backgroundColorDDataS, //二级选中菜单颜色
				rotateDeg: 10, //图标选中角度
				DownMenu: false,
				onchages: -1, //控制二级菜单的选中样式
				onchage: -1,
			}
		},
		created() {},
		mounted() {

		},
		activated() {},
		updated() {},
		methods: {
			// 一级菜单单击事件
			MenuDClick(NodeID, URL) {
				if (NodeID != this.onchage) {
					this.onchage = NodeID
					this.$router.push({
						path: URL
					})
				}
			},
			// 二级菜单的单击事件（最外层）
			MenuSClickW(index) {
				this.MenuList[index].Checked = !this.MenuList[index].Checked
			},
			// 二级菜单单击事件（最内层）
			DownSecondClick(NodeID, URL) {
				if (NodeID != this.onchages) {
					//console.log(NodeID, URL);
					this.onchages = NodeID
					this.$router.push({
						path: URL
					})
				}
			}
		},
		computed: {

		},
		watch: {
			// 默认左侧下拉展开
			MenuList(newVal, oldVal) {
				this.MenuList.map((item, index) => {
					item.Checked = true
				})
			},
			$route: {
				handler(to, from) {
					console.log(to, '新路由信息'); //新路由信息
					this.onchage = to.query.MenuID
					this.onchages = to.query.MenuID
					// if (to.name == "WorkReport") {
					//   this.onchage = 78
					// } else if (to.name == "QuotaManage") {
					//   this.onchage = 79
					// } else if (to.name == "NewAuthority") {
					//   this.onchage = 80
					// } else if (to.name == "firstbusiness") {
					//   this.onchages = 69
					// } else if (to.name == "Business") {
					//   this.onchages = 70
					// } else if (to.name == "ClassIImedical") {
					//   this.onchages = 71
					// }
				},
				// 深度观察监听
				deep: true,
				immediate: true
			}
		},
	}
</script>
<style scoped lang='less'>
	.leftMenu {
		position: absolute;
		user-select: none;
		height: 95%;
		overflow-y: auto;
		overflow-x: hidden;

		/* 滚动条样式 */
		&::-webkit-scrollbar {
			width: 4px;
			height: 4px;
		}

		&::-webkit-scrollbar-thumb {
			border-radius: 5px;
			background: #e0e0e0;
		}

		&::-webkit-scrollbar-track {
			border-radius: 5px;
			background: transparent;
		}

		.Menu {
			max-width: 258px;
			position: relative;
			// top: 20px;
			// overflow: hidden;

			.MenuD {
				width: 100%;
				height: 40px;
				color: #00266d;
				background-color: #f0f2f5;
				font-weight: 500;
				font-size: 14px;
				line-height: 40px;
				text-indent: 20px;
				transition: all 0.3s;
				cursor: pointer;
				overflow: hidden;
				transition: all .3s linear;

				.MenuDTitle {
					position: relative;
					top: -40px;
				}

				.MenuD-icon {
					position: relative;
					left: -20px;
					top: 5px;
					// width: 20px;
					// border: 1px solid red;
					// display: inline-block;
				}

				.MenuDR {
					width: 3px;
					height: 100%;
					background-color: #00266d;
					position: relative;
					left: 0px;
					top: -80px;
					float: right;
					transition: all 0.3s;
				}
			}

			.MenuDs {
				width: 100%;
				height: 40px;
				color: #16181a;
				font-weight: 500;
				font-size: 14px;
				line-height: 40px;
				text-indent: 20px;
				transition: all 0.3s;
				cursor: pointer;

				.MenuDTitle {
					position: relative;
					top: -40px;
				}

				.MenuD-icon {
					position: relative;
					left: -20px;
					top: 5px;
				}

				.MenuDR {
					width: 3px;
					height: 100%;
					background-color: #00266d;
					position: relative;
					left: 0px;
					top: -80px;
					float: right;
				}
			}

			.MenuDs:hover {
				background-color: #F0F2F5;
				transition: all 0.3s;
			}

			.MenuSBox {
				width: 100%;

				.MenuS {
					width: 100%;
					height: 40px;
					font-weight: 500;
					font-size: 14px;
					line-height: 40px;
					text-indent: 20px;
					background-color: #E6EAF2;
					cursor: pointer;


					.imgMenu {
						// border: 1px solid red;
						display: inline-block;
						vertical-align: middle;
						float: right;
						margin-right: 10px;
						margin-top: 10px;
						transform: rotate(180deg);
						transition: all 0.5s;
					}

					.imgsMenu {
						vertical-align: middle;
						float: right;
						margin-right: 10px;
						margin-top: 10px;
						transform: rotate(0deg);
						transition: all 0.5s;
					}
				}

				.DownList {
					width: 100%;
					height: 40px;
					background-color: #ffffff;
					position: relative;
					overflow: hidden;
					cursor: pointer;

					.DownData {
						font-weight: 500;
						font-size: 14px;
						line-height: 40px;
						text-indent: 40px;
						color: #424e66;
					}

					.DownDatas {
						font-weight: 500;
						font-size: 14px;
						line-height: 40px;
						text-indent: 40px;
						color: #424e66;
						background-color: #f0f2f5;
					}

					.DownData:hover {
						background-color: #f0f2f5;
						transition: all 0.5s;
					}

					.MenuS-icon {
						position: relative;
						left: -20px;
						top: 5px;
					}

					.MenuStitle {
						// border: 1px solid red;
						position: relative;
						// left: 10px;
						top: -40px;
					}

					.MenuDRScound {
						width: 3px;
						height: 40px;
						background-color: #00266d;
						// position: absolute;
						float: right;
						// left: 253px;
						margin-top: -79px;
					}

					.MenuDRScounds {
						width: 3px;
						height: 40px;
						// position: absolute;
						float: right;
						// left: 253px;
						margin-top: -79px;
					}
				}
			}

			.MenuS:hover {
				background-color: #E6EAF2;
				transition: all 0.3s;
			}
		}
	}
</style>